import useLockBodyScroll from './useLockBodyScroll';

const LockBodyScroll: FC = () => {
  useLockBodyScroll();
  return null;
};

export default LockBodyScroll;
